import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionLink from './ActionLink';
import BuilderCanvas from './BuilderCanvas';
import Message from './Message';

const DesignWarningMessage = (props) => {
	const promotion = props?.promotion ?? false;

	if(promotion === false) return null;

	const i18n = (m) => i18nIntl(m, props.intl);

	const is_wl = (promotion.promo_type == 2) ? true : false;

	return (
		<BuilderCanvas is_adaptable={false} not_awesome={true}>
			{(is_wl) && (
				<Message
					title="Generic custom code tip"
					_class={{ other:'in_top' }}
				>
					<p>{i18n("This code will be added only in this section pages.")} <FormattedMessage id="If you want to add a code that will need to be applied on every page of the promotion, you can use the {link}." values={{link:<ActionLink _href='#design/advanced'>Advanced Layout Section</ActionLink>}} /></p>
				</Message>
			)}

			<p>{i18n("Use this code to add a tracking pixel or whatever you need.")}</p>

			<p>{i18n("The code inserted here, will be added right before the closing BODY tag.")}</p>

			<ul class="bulleted_list">
				<li>{i18n("jQuery compatible.")}</li>

				<li>
					<ActionLink
						_href={`${window.zendesk_base_url}207884626`}
						_target="_blank"
					>See code examples and further information about custom code.</ActionLink>
				</li>
			</ul>
		</BuilderCanvas>
	);
}

export default injectIntl(DesignWarningMessage);